// Mirrored in applications/platform-app/components/web-analytics — change both.
import React from 'react';
import { useDash } from '../context';
import { BreakdownCard, useBreakdown } from './shared';
import { Card, Empty, ErrorLine, MoreButton, Note, Td, Th, rowButton } from '../ui';
import { duration, fmt, pct } from '../format';

const AllPages: React.FC = () => {
  const d = useDash();
  const q = useBreakdown('page', 20);
  const rows = q.data?.rows || [];
  return (
    <Card title="All pages" action={<MoreButton onClick={() => d.openViewAll('page', 'Pages')}>View all →</MoreButton>} testId="wa-all-pages">
      {q.error ? <ErrorLine message={q.error} /> : !rows.length ? <Empty /> : (
        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-[13px]">
            <thead><tr><Th>Page</Th><Th num>Views</Th><Th num>Visits</Th><Th num>Avg. time</Th><Th num>Entries</Th><Th num>Exit rate</Th></tr></thead>
            <tbody>
              {rows.map((r) => {
                const click = d.rowFilter('page', r.value);
                return (
                  <tr key={r.value} {...rowButton(click, `Filter by page ${r.value}`)}>
                    <Td><b>{r.value}</b></Td>
                    <Td num>{fmt(r.pv)}</Td>
                    <Td num>{fmt(r.visits)}</Td>
                    <Td num>{r.visits ? duration(r.durSec / r.visits) : '—'}</Td>
                    <Td num>{fmt(r.entries)}</Td>
                    {/* Filtered (lake) results carry no exits — the lake has no per-session exit page. */}
                    <Td num>{q.filtered ? '—' : r.pv ? pct(r.exits / r.pv) : '—'}</Td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
};

export const PagesTab: React.FC = () => (
  <div>
    <AllPages />
    <div className="grid gap-3.5 mt-3.5 grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
      <BreakdownCard title="Entry pages" dim="entry" value={(r) => r.entries || r.visits} viewAll />
      <BreakdownCard title="Site search terms" dim="search" value={(r) => r.hits || r.visits} viewAll />
      <BreakdownCard
        title="Broken links (404)" dim="notfound" value={(r) => r.hits || r.pv}
        note={<Note>Paths like /wp-login.php and /.env are probing attempts. You'll also find them on the Security tab.</Note>}
      />
    </div>
  </div>
);

export default PagesTab;
